import { useCallback } from 'react';

import { useBannerContext } from '@xing-com/crate-jobs-components-banner';

export const useJobBookmarkStatusBanners = (
  isBookmarked: boolean
): { onCompleted: () => void; onError: () => void } => {
  const { showErrorBanner, showSuccessBanner } = useBannerContext();
  const onCompleted = useCallback(() => {
    showSuccessBanner(
      isBookmarked
        ? 'JOBS_JOB_DETAILS_SAVE_JOB_NOTIFICATION_A11Y'
        : 'JOBS_JOB_DETAILS_UNSAVE_JOB_NOTIFICATION_A11Y'
    );
  }, [isBookmarked, showSuccessBanner]);
  const onError = useCallback(() => {
    showErrorBanner(
      isBookmarked
        ? 'JOBS_JOB_DETAILS_UNSAVE_JOB_NOTIFICATION_ERROR_A11Y'
        : 'JOBS_JOB_DETAILS_SAVE_JOB_NOTIFICATION_ERROR_A11Y'
    );
  }, [isBookmarked, showErrorBanner]);

  return { onCompleted, onError };
};
